module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markup-popup-form-notifications",
    class: _vm.classes
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "markup-popup-form-notifications__item",
      class: item.classes,
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bbbe76c8","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/markup/popup/form/notification/component.vue
// module id = 959dd29fc7bfe45d009e
// module chunks = 89